/**
 * Zakres dat „od–do” (YYYY-MM-DD) w formularzach: zmiana „od” pilnuje „do”.
 * - „do” puste albo wcześniejsze niż „od” → „do” = „od”;
 * - „do” ustawione i nie wcześniejsze → bez zmian;
 * - puste „od” niczego nie zmienia.
 * `keepEmpty` — dla pól, w których puste „do” znaczy „bez końca” (np. stałe członkostwo w ekipie):
 * puste „do” zostaje puste, poprawiane jest tylko „do” wcześniejsze niż „od”.
 */
export function clampDateTo(from: string, to: string, opts: { keepEmpty?: boolean } = {}): string {
  if (!from) return to;
  if (!to) return opts.keepEmpty ? to : from;
  return to < from ? from : to;
}
